/** @typedef {import('../inface-auth/inface-auth.class').InfaceAuth} InfaceAuth */

/**
 * web-auth SDK class 중 외부에 노출 할 API Module 을 생성합니다. 
 * @param {InfaceAuth} instance
 * @returns {InfaceAuthSDKApi}
 */
 function createSdkApis(instance) {
  
  return [{
    name: 'init',
    action: (...args) => instance.init(...args)
  }, {
    name: 'isSignedIn',
    action: (...args) => instance.isSignedIn(...args)
  }, {
    name: 'linkConsole',
    action: (...args) => instance.linkConsole(...args)
  }, {
    name: 'hasLinked',
    action: (...args) => instance.hasLinked(...args)
  }, {
    name: 'gotoSignIn',
    action: (...args) => instance.gotoSignIn(...args)
  }, {
    name: 'gotoSignOut',
    action: (...args) => instance.gotoSignOut(...args)
  }, {
    name: 'gotoSignUp',
    action: (...args) => instance.gotoSignUp(...args)
  }, {
    name: 'gotoAccount',
    action: (...args) => instance.gotoAccount(...args)
  }, {
    name: 'getProfile',
    action: (...args) => instance.getProfile(...args)
  }, {
    name: 'gotoLogin',
    action: (...args) => instance.gotoLogin(...args)
  }, {
    name: 'getCID',
    action: (...args) => instance.getCID(...args)
  }, {
    name: 'getToyMaintenances',
    action: (...args) => instance.getToyMaintenances(...args)
  }, {
    name: 'getEnv',
    action: () => instance.env
  }, {
    name: 'getWebToken',
    action: () => instance.webToken
  }, {
    name: 'getGID',
    action: () => instance.gid
  }]
}

export default createSdkApis
export { createSdkApis }
